export default __webpack_public_path__ + "static/media/blog-paver-walkway-010.987abe49.jpg";